import { useTranslation } from 'react-i18next';

import { Button } from '@/components/shared/buttons';

import style from './SavedFilters.module.sass';

type SavedFiltersDefaultSwitchProps = {
  value: boolean;
  onChange: (value: boolean) => void;
};

export const SavedFiltersDefaultSwitch = ({
  value,
  onChange,
}: SavedFiltersDefaultSwitchProps) => {
  const { t } = useTranslation();

  const toggleClassName = [
    style.defaultSwitchToggle,
    value ? style.isChecked : '',
  ].filter(Boolean).join(' ');

  return (
    <Button.Unstyled
      className={style.defaultSwitchCard}
      role='switch'
      aria-checked={value}
      onClick={() => onChange(!value)}>
      <span className={style.defaultSwitchCopy}>
        <span className={style.defaultSwitchTitle}>{t('savedFilters:defaultSwitchTitle')}</span>
        <span className={style.defaultSwitchDescription}>
          {t('savedFilters:defaultSwitchDescription')}
        </span>
      </span>
      <span className={toggleClassName} aria-hidden='true'>
        <span className={style.defaultSwitchThumb} />
      </span>
    </Button.Unstyled>
  );
};
